var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStarFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2836 4.45524C20.4453 2.36016 17.4796 2.36016 16.6414 4.45524L14.1561 10.6667C13.9397 11.2075 13.4298 11.5742 12.8483 11.6071L6.11886 11.9883C3.82889 12.1181 2.90774 15.0053 4.69949 16.4373L9.83718 20.5432C10.3029 20.9154 10.504 21.5281 10.3494 22.1039L8.65235 28.4254C8.06353 30.6187 10.4679 32.3975 12.393 31.1928L18.1668 27.5798C18.6535 27.2752 19.2715 27.2752 19.7582 27.5798L25.532 31.1928C27.4571 32.3975 29.8615 30.6187 29.2726 28.4254L27.5756 22.1039C27.421 21.5281 27.6221 20.9154 28.0878 20.5432L33.2255 16.4373C35.0173 15.0053 34.0961 12.1181 31.8061 11.9883L25.0767 11.6071C24.4951 11.5742 23.9852 11.2075 23.7689 10.6667L21.2836 4.45524Z",
    fill: "url(#paint0_linear_2267_162945)",
    stroke: "#FFA3DA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2267_162945",
    x1: 22.8723,
    y1: 37,
    x2: 22.4536,
    y2: -0.00189728,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BF3948"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#962BC7"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled);
export default __webpack_public_path__ + "static/media/star_filled.00f0cd3f6d2063bda1030034f2baca6a.svg";
export { ForwardRef as ReactComponent };